// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__js0GL","emails":"CreateEditClinics_emails__3qFEs","emailTagLabel":"CreateEditClinics_emailTagLabel__2211j"};